import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c1c92f2&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=3c1c92f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c92f2",
  null
  
)

export default component.exports